import { queryOptions, useQuery } from '@tanstack/react-query'
import { isObjectId } from '@/shared/lib'
import { ticketApi } from '../api/ticket-api'

/** Ответы поддержки пишутся на языке оператора — языка в ключе нет. */
export const ticketKeys = {
  all: ['tickets'] as const,
  list: () => [...ticketKeys.all, 'list'] as const,
  detail: (ticketId: string) => [...ticketKeys.all, 'detail', ticketId] as const,
}

/**
 * Свои обращения. Ответ поддержки приходит без уведомления в Mini App, поэтому
 * список перечитывается при каждом входе (`staleTime: 0`) и при возврате в
 * приложение.
 */
export const useTicketsQuery = () =>
  useQuery({
    queryKey: ticketKeys.list(),
    queryFn: ({ signal }) => ticketApi.list(signal),
    staleTime: 0,
  })

/**
 * Обращение с перепиской; негодный id — сразу «не найдено», без запроса. Те же
 * опции — у запроса заранее при входе по кнопке бота (`t_<id>`, `app/launch.ts`).
 */
export const ticketQueryOptions = (ticketId: string) =>
  queryOptions({
    queryKey: ticketKeys.detail(ticketId),
    queryFn: ({ signal }) => ticketApi.get(ticketId, signal),
    enabled: isObjectId(ticketId),
    staleTime: 0,
  })

export const useTicketQuery = (ticketId: string) => useQuery(ticketQueryOptions(ticketId))
